import styled, { css } from 'styled-components'
import { device } from '../../../styles/GlobalVariables'

export const SwiperButton = styled.button`
  cursor: pointer;
  position: absolute;
  z-index: 2;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;

  ${props => {
    switch (props.theme.role) {
      case 'prev':
        return css`
          right: 0;
          svg {
            transform: rotate(-180deg);
          }
        `
      case 'next':
        return css`
          left: 0;
        `
      default:
        return ''
    }
  }}
`
export const SwiperButtonContainer = styled.div`
  display: none;

  ${device.medium} {
    display: flex;
  }
`
